export default "__VITE_ASSET__DbPW2cOW__"